import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {  useNavigate, useParams } from 'react-router-dom';
import { fetchMainMeal, updateMainMeal } from '../hooks/MainMeals';
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar';
import CustomHeader from '../Components/CustomHeader/CustomHeader';
import CustomForm from '../Components/CustomForm/CustomForm';
import { Container } from 'react-bootstrap';

function EditMainMeal() {
  const dispatch = useDispatch();
const navigate = useNavigate();
const {id}=useParams()
    const { list } = useSelector((state) => state.resturants);
const {singleRestaurantg:restaurantData}=useSelector((state)=>state.resturants)
const {singleRestaurant:mealData}=useSelector((state)=>state.mainMeals)
console.log(list,"list");

useEffect(() => {
  
dispatch(fetchMainMeal({
    MainMealID:id,
  }))
}, [])
      const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        {
          id: "parent_id",
          title: "اختار الوجبة الاساسية",
          type: "select",
          options:[{id:10,name:"الافطار"},{id:11,name:"الغداء"},{id:12,name:"العشاء"}],
        },    {
          id: "restaurant_ids",
          title: "اختار المطعم",
          type: "select",
          options:list,
        },
                { id: "name", title: "اسم الوجبة", type: "text", },
                { id: "image", title: "صورة الوجبة", type: "file" },
                { id: "description", title: "وصف الوجبة", type: "textarea", },

            ],
    },
  ];
const handleSubmit = (formValues) => {
  console.log(formValues);
  
  const formData = new FormData();

  Object.keys(formValues).forEach((key) => {
    if (key === "restaurant_ids") {
      // لو multiple
      if (Array.isArray(formValues[key])) {
        formValues[key].forEach((id) => {
          formData.append("restaurant_ids[]", id);
        });
      } else {
        formData.append("restaurant_ids[]", Number(formValues[key]));
      }
    } else if (key === "image") {
      formData.append("image", formValues.image); // file
    } else {
      formData.append(key, formValues[key]);
    }
  });
  dispatch(updateMainMeal({ id, data: formData })) // ✅ هنا التعديل
    .unwrap() // Allows us to use .then() / .catch() on the thunk result
    .then(() => {
      alert("تم تعديل الوجبة بنجاح");
      navigate('/dashboard/main-meals'); // Redirect to list page
    })
    .catch((err) => {
      // Error is already handled in Redux, but you can do specific UI logic here
      console.error("Failed to save:", err);
    });
};
return (
  <div>
      <AuthNavbar/>
        <Container>
                  <CustomHeader
        title={"تعديل الوجبة الرئيسية "}
        subtitle={""}
        downloadData={false}
      />
      <CustomForm
formStructure={infoData}
image={false}
onSubmit={handleSubmit}
initialData={mealData}

      />
          </Container>
          </div>
)

}

export default EditMainMeal
